<template>
  <div class="offcanvas offcanvas-end" tabindex="-1" :id="offcanvas_id" data-bs-backdrop="static" :aria-labelledby="`${offcanvas_id}_label`">
    <div class="offcanvas-header">
      <button class="btn-back" type="button" name="button" data-test="btnCloseOffcanvas" data-bs-dismiss="offcanvas" aria-label="Close" @click="doConfirm">
        <IconArrowBack/>
        {{ $t('goBack') }}
      </button>
      <h5 class="offcanvas-title d-block" :id="`${offcanvas_id}_label`">{{ $t('plans.updateMethod.title') }}</h5>
    </div>

    <p>{{ $t('plans.updateMethod.subtitle') }}</p>

    <div class="offcanvas-body">
      <div id="checkout-update-payment">
        <!-- Checkout will insert the new payment method form here -->
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.offcanvas {
  p,
  li {
    color:                              var(--Brand-Primary, #1B294A);
    font-size:                          var(--font-size-14);
    font-weight:                        300;
    line-height:                        140%; /* 19.6px */
    margin-bottom:                      26px;
  }

  .offcanvas-header,
  .offcanvas-body {
    padding:                            0;
  }

  .offcanvas-header {
    display:                            block;
  }

  .offcanvas-title {
    color:                              var(--Brand-Primary, #1B294A);
    font-size:                          38px;
    font-weight:                        300;
    line-height:                        normal;
    margin:                             26px 0;
  }

  .offcanvas-footer {
    display:                            flex;
    flex-direction:                     column;
    gap:                                26px;

    .btn {
      font-size:                        var(--font-size-14);
      font-weight:                      700;
      line-height:                      normal;
      letter-spacing:                   4.2px;
      text-align:                       center;
      text-transform:                   uppercase;
      width:                            100%;
      padding:                          20px;
    }

    .btn-success {
      color:                            var(--Shades-W, #FFF);
    }
  }
}
</style>

<script>
import { inject } from "vue";
import { loadStripe } from "@stripe/stripe-js";

export default {
  name: 'PlansPaymentMethodUpdateOffcanvas',
  props: ['offcanvas_id'],
  data: () => ({
    loading: false,
    offcanvas_payment_method: null,
    clinicUUID: null,
    checkoutPaymentMethod: null,
    stripePaymentMethod: null,
    newPaymentMethodCompleted: false
  }),
  mounted() {
  },
  methods: {
    show(options = {}) {
      this.clinicUUID = options.clinicUUID
      this.newPaymentMethodCompleted = false

      this.offcanvas_payment_method = new bootstrap.Offcanvas(document.getElementById(this.offcanvas_id)).show();

      this.initializeCheckoutPaymenthMethod()

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },

    doConfirm() {
      this.offcanvas_payment_method = null;
      this.resetPaymentMethod()
      this.resolvePromise(this.newPaymentMethodCompleted)
    },

    doCancel() {
      this.offcanvas_payment_method = null;
      this.resetPaymentMethod()
      this.resolvePromise(this.newPaymentMethodCompleted)
    },

    async resetPaymentMethod() {
      if (this.loading)
        return

      if (this.checkoutPaymentMethod) {
        try {
          await this.checkoutPaymentMethod.destroy()
        } catch (err) {
          console.log('Error resetCheckout', err);
        }
      }

      this.checkoutPaymentMethod = null
      this.stripePaymentMethod = null

      const checkoutPaymentMethod = document.getElementById('checkout-update-payment')
      if (checkoutPaymentMethod)
        checkoutPaymentMethod.innerHTML = ''
    },

    async initializeCheckoutPaymenthMethod() {
      if (this.loading || this.checkoutPaymentMethod)
        return

      this.checkoutPaymentMethod = null;

      let params = {
        clinicUUID: this.clinicUUID,
      };

      const currentLocale = this.$i18n.locale === 'pt-br' ? 'pt-BR' : this.$i18n.locale;

      this.loading = true
      try {
        const fetchClientSecret = await this.$stripeService.updatePaymentMethod(params);

        let clientSecret = fetchClientSecret.clientSecret;

        this.stripePaymentMethod = await loadStripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY, {
          locale: currentLocale
        });

        try{
          if (this.stripePaymentMethod && this.stripePaymentMethod.initEmbeddedCheckout) {
            this.checkoutPaymentMethod = await this.stripePaymentMethod.initEmbeddedCheckout({
              clientSecret,
              onComplete:() => {
                this.newPaymentMethodCompleted = true;
              }
            });

            this.$nextTick(() => {
              if (this.checkoutPaymentMethod)
                this.checkoutPaymentMethod.mount("#checkout-update-payment");
            });

          } else {
            console.error("Stripe is not initialized correctly");
          }
        } catch(error) {
          console.error("Stripe is not initialized correctly. Error:", error);
        }
      } catch (err) {
        console.log("Error initializing checkout", err);
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
